import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import TreatmentPlanList from "./HomeVisit/TreatmentPlan/TreatmentPlanList";

import {
  fetchTreatmentPlans,
  deleteTreatmentPlan,
} from "../store/slices/treatmentPlanSlice";

const TreatmentPlan = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { treatmentPlans, isLoading } = useSelector(
    (state) => state.treatmentPlan
  );

  useEffect(() => {
    dispatch(fetchTreatmentPlans());
  }, [dispatch]);

  const handleAdd = () => navigate("/home-visit/treatment-plan/add");

  const handleEdit = (id) => {
    const plan = treatmentPlans.find((p) => p.id === id);
    navigate(`/home-visit/treatment-plan/edit/${id}`, {
      state: { assessment: plan },
    });
  };

  const handleDelete = async (id) => {
    await dispatch(deleteTreatmentPlan(id));
  };

  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />

        <div className="card">
          <div className="card-body p-0">
            <TreatmentPlanList
              records={treatmentPlans}
              loading={isLoading}
              onAdd={handleAdd}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default TreatmentPlan;
